import React from 'react';
import styled, { css } from 'styled-components';
import { responsiveText } from 'utilities/style';
import { palette, lightTheme, darkTheme } from 'theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { InlineCTA } from 'components/InlineCTAs';
import Container from 'components/Container';

import PostHeroImg from 'views/Blog/Detail/elements/PostHeroImg';
import {
  MetaWrapper,
  BlogCategories,
  ReadingTime,
  AuthorList
} from 'views/Blog/elements/BlogMeta';

const PostHeaderWrapper = styled.header`
  padding-top: 64px;
  ${props =>
    props.featured &&
    css`
      background: ${palette.grey[900]};
      margin-bottom: 128px;
    `}
`;

const TitleTypography = styled(Typography)`
  ${responsiveText(28, 42)}
`;

const ExcerptTypography = styled(Typography)`
  font-weight: 400;
`;

const FeaturedInlineCTA = styled(InlineCTA)`
  margin-top: 2em;
  margin-bottom: -96px;

  h5 {
    ${responsiveText(16, 18)}
  }

  img {
    min-height: 108px;
  }

  @media (max-width: 960px) {
    margin-bottom: 0;
  }

  @media (max-width: 600px) {
    img {
      display: none;
    }
  }
`;

const FeaturedDivider = styled(Divider)`
  position: relative;
  top: -36px;
`;

const PostHeader = ({
  blog_category,
  title,
  word_count,
  author,
  excerpt,
  hero_image,
  featured_card,
  featured,
  $
}) => (
  <PostHeaderWrapper featured={featured}>
    <MuiThemeProvider theme={featured ? darkTheme : lightTheme}>
      <Container>
        {featured && <FeaturedDivider />}
        <Grid container spacing={32}>
          <Grid item xs={12} md={6}>
            <MetaWrapper spacing={20}>
              <BlogCategories
                categories={blog_category}
                {...$?.blog_category}
              />
            </MetaWrapper>
            <TitleTypography variant="h1" {...$?.title}>
              {title}
            </TitleTypography>
            <MetaWrapper spacing={20}>
              <ReadingTime wordCount={word_count} divided {...$?.word_count} />
              <AuthorList authors={author} {...$?.author} />
            </MetaWrapper>
            {featured ? (
              <MuiThemeProvider theme={lightTheme}>
                <FeaturedInlineCTA
                  size="wide"
                  alignItems="flex-start"
                  {...featured_card}
                  {...$?.featured_card}
                />
              </MuiThemeProvider>
            ) : (
              <ExcerptTypography variant="h5" component="p" {...$?.excerpt}>
                {excerpt}
              </ExcerptTypography>
            )}
          </Grid>
          {hero_image && (
            <Grid item xs={12} md={6} {...hero_image.$?.uid}>
              <PostHeroImg
                src={hero_image.url}
                alt={title}
                maxWidth={560}
                disableLazyLoad
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </MuiThemeProvider>
  </PostHeaderWrapper>
);

export default PostHeader;
